import {reposWebApi} from "./customerAPI";
import qs from "querystring";
import {getAsset, logout, refreshToken} from "./sessionAction";
import secureLocalStorage from "react-secure-storage";
import {setData} from "./datumAction";
import {downloadFile} from "./orderActions";

export const ASSET_OUT_OF_SERVICE = " ASSET_OUT_OF_SERVICE";
export const GET_ASSETS = "GET_ALL_ASSETS";
export const CLEAR_ASSET_DATA = "CLEAR_ASSET_DATA";
export const CLEAR_TANK_ASSET = "CLEAR_TANK_ASSET";
export const GET_ASSETS_FAIL = "GET_ALL_ASSETS_FAIL";
export const ASSET_LOADING = "ASSET_LOADING";
export const ASSET_TYPE_COUNT = "ASSET_TYPE_COUNT";
export const CREATING_NEW_ASSET = "CREATING_NEW_ASSET";
export const CREATE_ASSET = "CREATE_NEW_ASSET";
export const GET_SINGLE_ASSET = "GET_SINGLE_ASSET";
export const EDIT_ASSET = "EDIT_ASSET";
export const CHANGE_ASSET_PASSWORD = "CHANGE_ASSET_PASSWORD";
export const EDIT_ASSET_FAIL = "EDIT_ASSET_FAIL";
export const CREATE_ASSET_FAIL = "CREATING_NEW_ASSET_FAIL";
export const DELETING_ASSET = "DELETE_ASSET_LOADING";
export const DELETE_ASSET = "DELETE_ASSET";
export const DELETE_ASSET_FAIL = "DELETE_ASSET_FAIL";
export const GET_DISPENSE_REPORTS = "GET_DISPENSE_REPORTS";
export const GET_DISPENSE_REPORTS_FAIL = "GET_DISPENSE_REPORTS_FAIL";
export const CREATE_DISPENSE = "CREATE_DISPENSE";
export const CREATE_DISPENSE_FAIL = "CREATE_DISPENSE_FAIL";
export const GET_REFILL_REPORTS = "GET_REFILL_REPORTS";
export const GET_REFILL_REPORTS_FAIL = "GET_REFILL_REPORTS_FAIL";
export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const GET_RPP_LIST = "GET_RPP_LIST";
export const GET_SINGLE_RPP = "GET_SINGLE_RPP";
export const GET_DATE = "GET_DATE";
export const GET_CITY_ASSET = "GET_CITY_ASSET";
export const IS_CITY_LOADING = 'IS_CITY_LOADING';
export const ASSET_TYPE_COUNT_LOADING = "ASSET_TYPE_COUNT_LOADING";
export const GET_CITY_FAIL = "GET_CITY_FAIL";
export const ASSET_LOCATION = 'ASSET_LOCATION';
export const GET_ASSET_LIST = 'GET_ASSET_LIST';
export const DATUM_HEALTH_LOADING = 'DATUM_HEALTH_LOADING';
export const DATUM_HEALTH = 'DATUM_HEALTH';
export const PLACE_ORDER_PAGE = 'PLACE_ORDER_PAGE';
export const GET_DATUM_GRAPH_DETAILS = "GET_DATUM_GRAPH_DETAILS";
export const GET_DATUM_GRAPH_DETAILS_FAIL = 'GET_DATUM_GRAPH_DETAILS_FAIL';
export const GET_REFILL_REPORTS_NOT_FOUND = 'GET_REFILL_REPORTS_NOT_FOUND';
export const GET_ASSET_LIST_FAIL = 'GET_ASSET_LIST_FAIL';
export const GET_SUBASSET_GRAPH_DETAILS = 'GET_SUBASSET_GRAPH_DETAILS';
export const GET_SUBASSET_GRAPH_DETAILS_FAIL = 'GET_SUBASSET_GRAPH_DETAILS_FAIL';
export const GET_ANALYTICS_REPORT = 'GET_ANALYTICS_REPORT';
export const GET_ANALYTICS_REPORT_FAIL = 'GET_ANALYTICS_REPORT_FAIL';
export const GET_SUB_ANALYTICS_REPORT = 'GET_SUB_ANALYTICS_REPORT';
export const GET_SUB_ANALYTICS_REPORT_FAIL = 'GET_SUB_ANALYTICS_REPORT_FAIL';
export const SUB_ASSET_ANALYTICS_LOADING = 'SUB_ASSET_ANALYTICS_LOADING';
export const SET_FORM_DATA = 'SET_FORM_DATA';
export const GET_MAIL_REPORTS = "GET_MAIL_REPORTS";
export const GET_MAIL_REPORTS_FAIL = "GET_MAIL_REPORTS_FAIL";
export const GET_DOWNLOAD_REPORTS_FAIL = "GET_DOWNLOAD_REPORTS_FAIL";
export const GET_DOWNLOAD_REPORTS = "GET_DOWNLOAD_REPORTS";
export const GET_DIP_LOG = 'GET_DIP_LOG';
export const GET_DIP_LOG_FAIL = 'GET_DIP_LOG_FAIL';
export const GET_PAYMENT_LIST = 'GET_PAYMENT_LIST';
export const PAYMENT_LIST_LOAD = 'PAYMENT_LIST_LOAD';
export const GST_NUMBER = 'GST_NUMBER';
export const GET_FUEL_LEVEL = "GET_FUEL_LEVEL";
export const EXTERNAL_REFILL = "EXTERNAL_REFILL";
export const ADD_EXTERNAL_REFILL = "ADD_EXTERNAL_REFILL";
export const ADD_EXTERNAL_REFILL_ERROR = "ADD_EXTERNAL_REFILL_ERROR";


let abortsignal = '';
export const getAllAssets = (search, pickup, asset_type, isNewOrder, limit, offset) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    let queryParams = {};
    queryParams.search = search;
    queryParams.asset_state = pickup;
    queryParams.asset_type = asset_type;
    queryParams.limit = limit;
    queryParams.offset = offset

    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });
        reposWebApi
            .get("/customer/v4/get_customer_assets", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
                params: queryParams,
                signal: signal,
            })
            .then((response) => {
                var i;
                for (i = 0; i < response?.data?.data?.length; ++i) {
                    if (response?.data?.data.results[i]?.asset_type === 1) {
                        secureLocalStorage.setItem("has_datum", true);
                        break;
                    } else {
                        secureLocalStorage.setItem("has_datum", false);
                    }
                }

                if (response?.status === 200) {
                    secureLocalStorage.setItem("assetCount", JSON.stringify(response?.data));
                    dispatch({
                        type: GET_ASSETS,
                        payload: response?.data?.data,
                    });
                }
            }).catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    setTimeout(dispatch(getAllAssets()), 3000);
                }
                if (error?.response?.state === 502 || error?.response?.state === 504) {
                    dispatch(logout());
                } else
                    dispatch({
                        type: GET_ASSETS_FAIL,
                    });
            });
    };
    // }
};

export const createAsset = (formData, enqueueSnackbar, history) => {
    return (dispatch) => {
        dispatch({
            type: CREATING_NEW_ASSET,
        });
        reposWebApi
            .post("/customer/create/new/asset", qs.stringify(formData), {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            })
            .then((response) => {
                enqueueSnackbar(response.data.data, {
                    variant: 'success'
                });
                dispatch({
                    type: CREATE_ASSET,
                    payload: response?.data?.data,
                });
                history.push('/newassets')
                // dispatch(getAllAssets());
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(createAsset());
                } else if (error?.response?.status === 400) {
                    enqueueSnackbar(error?.response?.data?.data, {
                        variant: 'error'
                    });
                    dispatch({
                        type: CREATE_ASSET_FAIL,
                        payload: true,
                    });
                } else
                    dispatch({
                        type: CREATE_ASSET_FAIL,
                        payload: true,
                    });
            });
    };
};


export const getAssetAnalytics = (formData, enqueueSnackbar, fetchMoreData) => {
    return (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ASSET_LOADING,
            });
        }
        reposWebApi.get("/customer/get_assets_analytics", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_ANALYTICS_REPORT,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getAssetAnalytics());
                } else {
                    enqueueSnackbar("Something Went Wrong..!", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_ANALYTICS_REPORT_FAIL,
                    });
                }

            });
    };
};


export const getSubAssetAnalytics = (formData, fetchMoreData) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        // if (!fetchMoreData) {
        dispatch({
            type: SUB_ASSET_ANALYTICS_LOADING,
        });
        // }
        reposWebApi.get("/customer/get_sub_asset_analytics", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            signal: signal,
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_SUB_ANALYTICS_REPORT,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getSubAssetAnalytics());
                } else {

                    dispatch({
                        type: GET_SUB_ANALYTICS_REPORT_FAIL,
                    });
                }

            });
    };
};

export const getSingleAsset = (asset) => {
    return (dispatch) => {
        dispatch({
            type: GET_SINGLE_ASSET,
            payload: asset,
        });
    };
};

export const getDate = (date) => {
    return (dispatch) => {
        dispatch({
            type: GET_DATE,
            payload: date,
        });
    };
};

export const getSingleRPP = (rpp) => {
    return (dispatch) => {
        dispatch({
            type: GET_SINGLE_RPP,
            payload: rpp,
        });
    };
};

export const getRPPList = (value) => {
    return (dispatch) => {
        dispatch({
            type: GET_RPP_LIST,
            payload: value,
        });
    };
};

// export const assetLocation = (value) => {
//     return (dispatch) => {
//         dispatch({
//             type: ASSET_LOCATION,
//             payload: value,
//         });
//     };
// }

export const editAsset = (formData, enqueueSnackbar, history) => {
    return (dispatch) => {
        dispatch({
            type: CREATING_NEW_ASSET,
        });
        // Return the promise so callers can await and handle success/failure
        return reposWebApi
            .post("/customer/update/asset", qs.stringify(formData), {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            })
            .then((response) => {
                enqueueSnackbar(formData?.asset_type === 1 ? "Asset updated successfully" : response.data.data, {
                    variant: 'success'
                });
                dispatch({
                    type: EDIT_ASSET,
                    payload: response?.data?.data,
                });
                dispatch(getSingleRPP(formData))
                dispatch(setData({
                    OpenDetails: false,
                    isDatum: false,
                    isDashboard: false,
                    datumData: [],
                }));
                if(history){
                    window.history.back()
                }
                // dispatch(getAllAssets());
                return response;
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(editAsset());
                }
                if (error?.response?.status === 400) {
                    enqueueSnackbar(error?.response?.data?.data, {
                        variant: 'error'
                    });
                    dispatch({
                        type: EDIT_ASSET_FAIL,
                        payload: true,
                    });
                } else
                    dispatch({
                        type: EDIT_ASSET_FAIL,
                        payload: true,
                    });
                // Rethrow so callers awaiting the dispatch can catch and handle failure
                return Promise.reject(error);
            });
    };
};

export const changeCredentials = (username, password, enqueueSnackbar) => {
    const requestBody = {
        username,
        password
    };
    return (dispatch) => {
        dispatch({
            type: CREATING_NEW_ASSET,
        });
        reposWebApi
            .post("/customer/change_datum_credentials", qs.stringify(requestBody), {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            })
            .then((response) => {
                enqueueSnackbar(response.data.data, {
                    variant: 'success',
                    horizontal: 'center'
                });
                dispatch({
                    type: CHANGE_ASSET_PASSWORD,
                    payload: response?.data,
                });
                dispatch(getAllAssets());
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(changeCredentials());
                }
                if (error?.response?.status === 400) {
                    alert("Invalid Pin Code");
                    dispatch({
                        type: EDIT_ASSET_FAIL,
                        payload: true,
                    });
                } else
                    enqueueSnackbar('Something went wrong..!, Please Try Again later', {
                        variant: 'error',
                        horizontal: 'center'
                    });
                dispatch({
                    type: EDIT_ASSET_FAIL,
                    payload: true,
                });
            });
    };
};

export const mailDatumReport = (formData, enqueueSnackbar, model) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });
        reposWebApi
            .get(model?.includes("X") || model === "S"  ? "/customer/datumx_report_mail" : "/customer/datum/dispense/report/mail", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
                signal: signal,
                params: formData,
            })
            .then((response) => {
                if (response?.status === 200) {

                    dispatch({
                        type: GET_MAIL_REPORTS,
                        payload: response?.data?.data,
                    });

                    enqueueSnackbar(response?.data?.data, {
                        variant: 'success',
                        horizontal: 'right',
                        vertical: 'top'
                    });

                }
            }).catch((error) => {
                if (error.response?.status === 401) {
                    enqueueSnackbar("Session Expired..!", {
                        variant: 'warning',
                        horizontal: 'center'
                    });
                    dispatch(refreshToken());
                    dispatch(getDispenseReports(formData, enqueueSnackbar));
                } else if (error.response?.status >= 500) {
                    enqueueSnackbar("Something went wrong..! Please Try Again later", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_MAIL_REPORTS_FAIL,
                        payload: true,
                    });
                }
            });
    };
}

export const getDispenseReports = (formData, enqueueSnackbar, scrollToPreview, fetchMoreData) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ASSET_LOADING,
            });
            dispatch(clearAssetData())
        }
        reposWebApi
            .get("/customer/get_datum_dispense_refill", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
                signal: signal,
                params: formData,
            })
            .then((response) => {
                if (response?.status === 200) {

                    dispatch({
                        type: GET_DISPENSE_REPORTS,
                        payload: response?.data?.data,
                        // .data.results,
                    });
                    scrollToPreview();

                }
            }).catch((error) => {
                if (error.response?.status === 401) {
                    enqueueSnackbar("Session Expired..!", {
                        variant: 'warning',
                        horizontal: 'center'
                    });
                    dispatch(refreshToken());
                    dispatch(getDispenseReports(formData, enqueueSnackbar, scrollToPreview));
                } else if (error.response?.status >= 500) {
                    enqueueSnackbar("Something went wrong..! Please Try Again later", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_DISPENSE_REPORTS_FAIL,
                        payload: true,
                    });
                }
            });
    };

};

export const getRefillReports = (formData, enqueueSnackbar, fetchMoreData) => {

    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ASSET_LOADING,
            });
        }
        reposWebApi.get("/customer/asset/refill/v2/list", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            signal: signal,
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_REFILL_REPORTS,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getRefillReports());
                } else if (error?.response?.status === 404) {
                    enqueueSnackbar(error?.response?.data?.data?.error, {
                        variant: 'info',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_REFILL_REPORTS_NOT_FOUND
                    });
                } else {
                    enqueueSnackbar("Something Went Wrong..!", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_REFILL_REPORTS_FAIL,
                        payload: true,
                    });
                }
            });
    };
};

export const deleteAssetAction = (assetId) => {
    const requestBody = {
        asset_id: assetId,
    };
    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });
        reposWebApi
            .post("/customer/delete/asset", qs.stringify(requestBody), {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            })
            .then((response) => {
                dispatch({
                    type: DELETE_ASSET,
                    payload: response?.data?.data,
                });
                dispatch(getAllAssets());
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(deleteAssetAction());
                }
                dispatch({
                    type: DELETE_ASSET_FAIL,
                    payload: error,
                });
            });
    };
};

export const createDispense = (dispenseEntry) => {
    var userData = JSON.parse(secureLocalStorage.getItem("user"));

    const requestBody = {
        quantity: dispenseEntry.quantity,
        dispensed_to: dispenseEntry.vehicle,
        asset_id: dispenseEntry.asset_id,
        dispensed_by: dispenseEntry.executive,
        customer_id: userData.user_details.id,
    };

    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });
        reposWebApi
            .post("/order/place_customer_order", qs.stringify(requestBody), {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            })
            .then((response) => {
                dispatch({
                    type: CREATE_DISPENSE,
                    payload: response.status,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(createDispense());
                }
                dispatch({
                    type: CREATE_DISPENSE_FAIL,
                    payload: error,
                });
            });
    };
};


export const AssetTypeCount = (searchKey, asset_state, isPlaceOrder, setAsset_type) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        dispatch({
            type: ASSET_TYPE_COUNT_LOADING,
        });
        reposWebApi
            .get("customer/asset_type_count", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
                signal: signal,
            })
            .then((response) => {
                secureLocalStorage.setItem('asset_type', JSON.stringify(response))
                secureLocalStorage.setItem('datum_count', JSON.stringify(response?.data?.data[0]?.asset_type_count))
                dispatch({
                    type: ASSET_TYPE_COUNT,
                    payload: response?.data?.data,
                });
                if (response?.data?.data[0]?.asset_type_count !== 0) {
                    setAsset_type && setAsset_type(1);
                    !isPlaceOrder &&
                        dispatch(getAsset(searchKey, asset_state,
                            (response?.data?.data[0]?.asset_type__type === 1
                                && response?.data?.data[0]?.asset_type_count !== 0) ? 1 : undefined, undefined))

                } else {
                    dispatch(getAsset(searchKey, asset_state, undefined, undefined))
                }
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(AssetTypeCount());
                }
                if (error?.response?.state === 502 || error?.response?.state === 504) {
                    dispatch(logout());
                } else
                    dispatch({
                        type: GET_ASSETS_FAIL,
                    });
            });
    };
    // }
};

export const getCity = (pickup) => {
    return (dispatch) => {
        dispatch({
            type: IS_CITY_LOADING
        });
        reposWebApi
            .get("customer/list_customerasset_city", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
                params: {
                    movable: pickup
                }
            })
            .then((response) => {
                dispatch({
                    type: GET_CITY_ASSET,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getCity());
                }
                if (error?.response?.state === 502 || error?.response?.state === 504) {
                    dispatch(logout());
                } else
                    dispatch({
                        type: GET_CITY_FAIL,
                    });
            });
    };
}

//*** Asset Out of Service api. ****//

export const setAssetOutOfervice = (asset_id, value) => {
    const requestBody = {
        is_active: asset_id,
        asset_id: value,
    };

    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });
        reposWebApi
            .post("/customer/asset_out_of_service", qs.stringify(requestBody), {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
            })
            .then((response) => {
                dispatch({
                    type: ASSET_OUT_OF_SERVICE,
                    payload: response.status,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(setAssetOutOfervice());
                }
                dispatch({
                    type: CREATE_DISPENSE_FAIL,
                    payload: error,
                });
            });
    };
};

export const getDatumHealth = (param) => {

    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        dispatch({
            type: DATUM_HEALTH_LOADING,
        });
        reposWebApi.get("customer/get_datum_health", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            signal: signal,
            params: {
                asset_id: param
            },
        })
            .then((response) => {
                dispatch({
                    type: DATUM_HEALTH,
                    payload: response.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getDatumHealth());
                } else {

                }
            });
    }
};

export const formData = (data) => {
    return (dispatch) => {
        dispatch({
            type: SET_FORM_DATA,
            payload: data
        })
    }
}


//  **************** Datum Graph List API ************************
export const getDatumGraphDetails = (formData, loadChart, datum_model) => {

    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        await reposWebApi.get((datum_model === 'X' || datum_model === 'X2' || datum_model === 'S') ? '/customer/get_graph_datumx' : '/customer/graph_refill_dispense', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            params: formData
        }).then(response => {
            dispatch({
                type: GET_DATUM_GRAPH_DETAILS,
                payload: response?.data?.data
            });
            loadChart(response?.data?.data);
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(getDatumGraphDetails(formData, loadChart, datum_model))
            } else dispatch({
                type: GET_DATUM_GRAPH_DETAILS_FAIL,
                payload: error
            })
        });
    }
};


export const getSubAssetGraphDetails = (formData, loadChart) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        await reposWebApi.post('/customer/graph_datum_dispense', qs.stringify(formData), {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
        }).then(response => {
            dispatch({
                type: GET_SUBASSET_GRAPH_DETAILS,
                payload: response?.data?.data
            });
            loadChart(response?.data?.data);
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(getSubAssetGraphDetails(formData, loadChart))
            } else dispatch({
                type: GET_SUBASSET_GRAPH_DETAILS_FAIL,
                payload: error
            })
        });
    }
};


export const getSubAssetList = () => {
    return async (dispatch) => {
        // dispatch({
        //     type: ASSET_LOADING,
        // })
        await reposWebApi.get('/customer/v2_get_assets_list', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
        }).then(response => {
            dispatch({
                type: GET_ASSET_LIST,
                payload: response?.data?.data
            });
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(getSubAssetList())
            } else dispatch({
                type: GET_ASSET_LIST_FAIL,
                payload: error
            })
        });
    }
};


export const editAssetIncharge = (formData, enqueueSnackbar, setAssetInchargeClose) => {
    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        await reposWebApi.post('/customer/edit_asset_incharge', qs.stringify(formData), {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            }
        }).then(response => {
            enqueueSnackbar(response?.data?.data?.msg, {
                variant: 'success',
                horizontal: 'center'
            });
            setAssetInchargeClose && setAssetInchargeClose()
            dispatch(getAllAssets());
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(editAssetIncharge(formData, enqueueSnackbar, setAssetInchargeClose))
            }
            enqueueSnackbar("Something Went Wrong..!", {
                variant: 'error',
                horizontal: 'center'
            });
        });
    }
}

export const sendDespendedViaMail = (formData, enqueueSnackbar,) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        await reposWebApi.get('/customer/datum/dispense/report/mail', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: formData
        }).then(response => {
            enqueueSnackbar(response?.data?.data, {
                variant: 'success',
                horizontal: 'center'
            });
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(sendDespendedViaMail(formData, enqueueSnackbar))
            }
            enqueueSnackbar("Something Went Wrong..!", {
                variant: 'error',
                horizontal: 'center'
            });
        });
    }
}

export const sendRefillViaMail = (formData, enqueueSnackbar,) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        await reposWebApi.get('/customer/datum/dispense/report/mail', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: formData
        }).then(response => {
            enqueueSnackbar(response?.data?.data, {
                variant: 'success',
                horizontal: 'center'
            });
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(sendDespendedViaMail(formData, enqueueSnackbar))
            }
            enqueueSnackbar("Something Went Wrong..!", {
                variant: 'error',
                horizontal: 'center'
            });
        });
    }
}


export const graphDatumDispense = (formData, enqueueSnackbar,) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
        await reposWebApi.get('/customer/graph_datum_dispense', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            signal: signal,
            params: formData
        }).then(response => {
            enqueueSnackbar(response?.data?.data, {
                variant: 'success',
                horizontal: 'center'
            });
        }).catch(async error => {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                dispatch(sendDespendedViaMail(formData, enqueueSnackbar))
            }
            enqueueSnackbar("Something Went Wrong..!", {
                variant: 'error',
                horizontal: 'center'
            });
        });
    }
}

export const isAssetLoading = () => {
    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        })
    }
}

export const isNewOrderPage = (value) => {
    return (dispatch) => {
        dispatch({
            type: PLACE_ORDER_PAGE,
            payload: value
        })
    }
}
export const clearAssetData = () => {
    return (dispatch) => {
        dispatch({
            type: CLEAR_ASSET_DATA,
        })
    }

};

export const clearTankAsset = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_TANK_ASSET,
    });
  }
};

const DATUM_XS_DOWNLOAD_TIMEOUT_MS = 60000;

const isRequestTimeoutError = (error) =>
    error?.code === 'ECONNABORTED' ||
    (typeof error?.message === 'string' && error.message.toLowerCase().includes('timeout'));

const isRequestCanceledError = (error) =>
    error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError';

export const downloadDatumReport = (formData, enqueueSnackbar) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    const isDatumXSExcelDownload = formData?.is_excel === 1 && formData?.date_format != null;

    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });

        if (isDatumXSExcelDownload) {
            const datumXDownloadParams = { ...formData };
            delete datumXDownloadParams.is_excel;
            delete datumXDownloadParams.is_mail;
            delete datumXDownloadParams.datumx_excel_download;

            return reposWebApi
                .get("/customer/datumx_report_download", {
                    headers: {
                        Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                    },
                    signal: signal,
                    params: datumXDownloadParams,
                    responseType: 'blob',
                    timeout: DATUM_XS_DOWNLOAD_TIMEOUT_MS,
                })
                .then((response) => {
                    if (response?.status === 200) {
                        const contentDisposition = response.headers?.['content-disposition'] || '';
                        const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
                        const filename = filenameMatch
                            ? filenameMatch[1]
                            : `datum-x_report_${Date.now()}.xlsx`;
                        const blob = new Blob([response.data], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url);

                        dispatch({
                            type: GET_DOWNLOAD_REPORTS,
                            payload: null,
                        });

                        enqueueSnackbar("Report Downloaded Successfully", {
                            variant: 'success',
                            horizontal: 'right',
                            vertical: 'top',
                        });
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: GET_DOWNLOAD_REPORTS_FAIL,
                        payload: true,
                    });

                    if (isRequestCanceledError(error)) {
                        return;
                    }

                    if (error.response?.status === 401) {
                        enqueueSnackbar("Session Expired..!", {
                            variant: 'warning',
                            horizontal: 'center',
                        });
                        dispatch(refreshToken());
                        return Promise.reject(error);
                    }

                    if (isRequestTimeoutError(error)) {
                        enqueueSnackbar("The report is taking longer than expected. Please try again.", {
                            variant: 'error',
                            horizontal: 'center',
                        });
                        return Promise.reject(error);
                    }

                    enqueueSnackbar("Couldn't download the Report. Please Retry", {
                        variant: 'error',
                        horizontal: 'center',
                    });
                    return Promise.reject(error);
                });
        }

        reposWebApi
            .get("/customer/download_csv_to_pdf", {
                headers: {
                    Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
                },
                signal: signal,
                params: formData,
                responseType: 'blob',  // Important to handle file downloads
            })
            .then((response) => {
                if (response?.status === 200) {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `report_${formData.start_date}_to_${formData.end_date}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    
                    // Open PDF in a new tab automatically
                    window.open(url, '_blank');

                    // Optionally dispatch success action (if needed)
                    dispatch({
                        type: GET_DOWNLOAD_REPORTS,
                        payload: response?.data?.data, // Modify payload according to your needs
                    });

                    enqueueSnackbar("Report Downloaded successfully!", {
                        variant: 'success',
                        horizontal: 'right',
                        vertical: 'top',
                    });
                }
            })
            .catch((error) => {
                if (error.response?.status === 401) {
                    enqueueSnackbar("Session Expired..!", {
                        variant: 'warning',
                        horizontal: 'center',
                    });
                    dispatch(refreshToken());
                    dispatch(getDispenseReports(formData, enqueueSnackbar));
                } else if (error.response?.status === 404) {
                    enqueueSnackbar("Oops! There's no data to download for the chosen duration. Please try a different range...!", {
                        variant: 'info',
                        horizontal: 'center',
                    });
                } else if (error.response?.status >= 500) {
                    enqueueSnackbar("Something went wrong..! Please Try Again later", {
                        variant: 'error',
                        horizontal: 'center',
                    });
                    dispatch({
                        type: GET_DOWNLOAD_REPORTS_FAIL,
                        payload: true,
                    });
                }
            });
    };
};

export const mailCombinedDatumReport = (formData, enqueueSnackbar) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        dispatch({ type: ASSET_LOADING });

        reposWebApi
            .get('/customer/datum/combined/report', {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                },
                signal,
                params: {
                    ...formData,
                    is_mail: 1,
                },
            })
            .then((response) => {
                if (response?.status === 200) {
                    dispatch({
                        type: GET_MAIL_REPORTS,
                        payload: response?.data?.meta?.message,
                    });
                    enqueueSnackbar(
                        response?.data?.meta?.message ||
                            'Combined Report sent successfully to your registered email address',
                        { variant: 'success', horizontal: 'right', vertical: 'top' }
                    );
                }
            })
            .catch((error) => {
                if (error.response?.status === 401) {
                    enqueueSnackbar('Session Expired..!', { variant: 'warning', horizontal: 'center' });
                    dispatch(refreshToken());
                } else if (error.response?.status >= 500) {
                    enqueueSnackbar('Something went wrong..! Please Try Again later', {
                        variant: 'error',
                        horizontal: 'center',
                    });
                    dispatch({ type: GET_MAIL_REPORTS_FAIL, payload: true });
                }
            });
    };
};

export const downloadCombinedDatumReport = (formData, enqueueSnackbar) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        dispatch({ type: ASSET_LOADING });

        reposWebApi
            .get('/customer/datum/combined/report', {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem('access_token'),
                },
                signal,
                params: {
                    ...formData,
                    is_mail: 0,
                },
                responseType: 'blob',
            })
            .then((response) => {
                if (response?.status === 200) {
                    // Extract filename from Content-Disposition header if available
                    const contentDisposition = response.headers?.['content-disposition'] || '';
                    const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
                    const filename = filenameMatch
                        ? filenameMatch[1]
                        : `combined_report_${formData.asset_id}.xlsx`;

                    const isPdf = filename.toLowerCase().endsWith('.pdf');
                    const blobType = isPdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    const blob = new Blob([response.data], { type: blobType });
                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    if (isPdf) {
                        // Open PDF in a new tab automatically
                        window.open(url, '_blank');
                    } else {
                        window.URL.revokeObjectURL(url);
                    }

                    dispatch({ type: GET_DOWNLOAD_REPORTS, payload: null });

                    enqueueSnackbar('Report downloaded successfully!', {
                        variant: 'success',
                        horizontal: 'right',
                        vertical: 'top',
                    });
                }
            })
            .catch((error) => {
                if (error.response?.status === 401) {
                    enqueueSnackbar('Session Expired..!', { variant: 'warning', horizontal: 'center' });
                    dispatch(refreshToken());
                } else if (error.response?.status === 404) {
                    enqueueSnackbar(
                        "Oops! There's no data to download for the chosen duration. Please try a different range...!",
                        { variant: 'info', horizontal: 'center' }
                    );
                } else if (error.response?.status >= 500) {
                    enqueueSnackbar('Something went wrong..! Please Try Again later', {
                        variant: 'error',
                        horizontal: 'center',
                    });
                    dispatch({ type: GET_DOWNLOAD_REPORTS_FAIL, payload: true });
                }
            });
    };
};

export const getDipLogs = (formData, fetchMoreData) => {

    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ASSET_LOADING,
            });
        }
        reposWebApi.get("/tracker/get_reconciliation", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            signal: signal,
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_DIP_LOG,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                dispatch({
                    type: GET_ASSETS_FAIL,
                });
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getDipLogs(formData, fetchMoreData));
                }
            });
    };
};

export const getJarTest = (formData) => {

    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });
        reposWebApi.get("/order/list/jar_test", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            signal: signal,
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_DIP_LOG,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                dispatch({
                    type: GET_ASSETS_FAIL,
                });
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getJarTest(formData));
                }
            });
    };
};

export const getJarTestSummary = (formData) => {
    return async (dispatch) => {
        const abortController = new AbortController();

        try {
            const response = await reposWebApi.get("/order/list/test_status", {
                headers: {
                    Authorization: `Bearer ${secureLocalStorage.getItem("access_token") || ""}`,
                },
                signal: abortController.signal,
                params: formData,
            });
            return response?.data
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return dispatch(getJarTestSummary(formData));
            }
            return { error: error?.response?.status, errorMessage: error?.response?.data?.data }
        }
    };
};

export const getJarTestOrder = (formData) => {
    return async (dispatch) => {
        const abortController = new AbortController();
        try {
            const response = await reposWebApi.get("/order/list/accept_reject_order", {
                headers: {
                    Authorization: `Bearer ${secureLocalStorage.getItem("access_token") || ""}`,
                },
                signal: abortController.signal,
                params: formData,
            });
            return response?.data
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return dispatch(getJarTestOrder(formData));
            }
            if (error?.response?.status) {
                return { error: error?.response?.status, errorMessage: error?.response?.data?.data }
            }
            return { error: 'Server Error' }
        }
    };
};

export const getManageOrder = (formData) => {
    return async (dispatch) => {
        const abortController = new AbortController();
        try {
            const response = await reposWebApi.post("/order/jartest_accept_reject", qs.stringify(formData), {
                headers: {
                    Authorization: `Bearer ${secureLocalStorage.getItem("access_token") || ""}`,
                },
                signal: abortController.signal,
            });
            return response?.data
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return dispatch(getManageOrder(formData));
            }
            return { error: error?.response?.status, errorMessage: error?.response?.data?.data }
        }
    };
};

export const sendRemainder = (formData) => {
    return async (dispatch) => {
        const abortController = new AbortController();
        try {
            const response = await reposWebApi.post("/order/send_jartest_reminder", qs.stringify(formData), {
                headers: {
                    Authorization: `Bearer ${secureLocalStorage.getItem("access_token") || ""}`,
                },
                signal: abortController.signal,
            });
            return response?.data
        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken());
                return dispatch(sendRemainder(formData));
            }
            return { error: error?.response?.status, errorMessage: error?.response?.data?.data }
        }
    };
};

export const getPaymentList = (formData, enqueueSnackbar) => {
    if (abortsignal) {
        abortsignal.abort();
    }

    abortsignal = new AbortController();
    const signal = abortsignal.signal;

    return (dispatch) => {
        dispatch({
            type: PAYMENT_LIST_LOAD,
        })
        // Custom params serializer to handle arrays as [value1, value2] format
        const paramsSerializer = (params) => {
            const searchParams = new URLSearchParams();
            Object.keys(params).forEach(key => {
                const value = params[key];
                if (Array.isArray(value)) {
                    // Format array as [value1, value2, value3]
                    searchParams.append(key, `[${value.join(', ')}]`);
                } else if (value !== null && value !== undefined) {
                    searchParams.append(key, value);
                }
            });
            return searchParams.toString();
        };

        reposWebApi.get("/rfd_subscription/v2/list/payment", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            signal: signal,
            params: formData,
            paramsSerializer: paramsSerializer,
        })
            .then((response) => {
                dispatch({
                    type: GET_PAYMENT_LIST,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getPaymentList(formData, enqueueSnackbar));
                } else if (error?.response?.status === 404) {
                    enqueueSnackbar(error?.response?.data?.data?.error || "Something Went Wrong..!" + error?.response?.status, {
                        variant: 'info',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_REFILL_REPORTS_NOT_FOUND
                    });
                } else {
                    enqueueSnackbar("Something Went Wrong..!", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_REFILL_REPORTS_FAIL,
                        payload: true,
                    });
                }
            });
    };
};

export const sendInvoice = (formData, enqueueSnackbar) => {
    return async (dispatch) => {
        const abortController = new AbortController();
        try {
            const response = await reposWebApi.post("/rfd_subscription/v2/send_email_or_download", qs.stringify(formData), {
                headers: {
                    Authorization: `Bearer ${secureLocalStorage.getItem("access_token") || ""}`,
                },
                signal: abortController.signal,
            });
            if (response?.status === 200) {
                enqueueSnackbar(response?.data?.data || 'Invoice sent successfully', {
                    variant: 'success',
                    horizontal: 'center'
                })
            }
            return response?.data
        } catch (error) {
            if (error?.response?.status === 401) {
                enqueueSnackbar('Session Expired..!', {
                    variant: 'error',
                    horizontal: 'center'
                })
                await dispatch(refreshToken());
                return dispatch(sendInvoice(formData, enqueueSnackbar));
            }
            enqueueSnackbar('Something Went Wrong..!', {
                variant: 'error',
                horizontal: 'center'
            })
            return { error: error?.response?.status, errorMessage: error?.response?.data?.data }
        }
    };
};

export const downloadInvoices = (formData, enqueueSnackbar, onProgress) => {
    return () => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${reposWebApi.defaults.baseURL}/rfd_subscription/v2/send_email_or_download`);

            // Set headers
            xhr.setRequestHeader('Authorization', `Bearer ${secureLocalStorage.getItem("access_token")}`);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.responseType = 'blob';

            // Track download progress
            xhr.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    if (onProgress) {
                        onProgress(percentComplete);
                    }
                }
            };

            xhr.onload = function () {
                if (xhr.status === 200) {
                    const response = {
                        data: xhr.response,
                        status: xhr.status
                    };
                    downloadFile(response);
                    enqueueSnackbar("Report Downloaded Successfully!", { variant: "success" });
                    resolve(response);
                } else {
                    const error = new Error('Download failed');
                    error.status = xhr.status;
                    enqueueSnackbar(
                        error?.status >= 500
                            ? "Something went wrong! Please try again later."
                            : "Request failed.",
                        { variant: "error" }
                    );
                    reject(error);
                }
            };

            xhr.onerror = function () {
                const error = new Error('Network error occurred');
                enqueueSnackbar("Network error occurred!", { variant: "error" });
                reject(error);
            };

            // Send form data
            xhr.send(qs.stringify(formData));
        });
    };
};

export const getSingleAssetData = (id) => {
    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });

        const requestBody = {
            search: id,
        };

        try {
            const response = await reposWebApi.get('/customer/v2/get_customer_assets', {
                headers: {
                    Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
                },
                params: requestBody
            });

            dispatch({
                type: GET_SINGLE_ASSET,
                payload: response?.data?.data?.results?.[0] || response?.data?.data,
            });

            return response?.data?.data;

        } catch (error) {
            if (error?.response?.status === 401) {
                await dispatch(refreshToken())
                return dispatch(getSingleAssetData(id))
            }

            if (error?.response?.status === 502 || error?.response?.status === 504) {
                dispatch(logout());
            } else {
                dispatch({
                    type: GET_ASSETS_FAIL,
                    payload: {
                        error: error?.response?.data?.message || 'Failed to fetch asset data',
                        status: error?.response?.status
                    }
                });
            }

            throw error;
        }
    };
};

export const getGstNumber = (value) => {
    return async (dispatch) => {
        dispatch({
            type: ASSET_LOADING,
        });
        await reposWebApi.get('/customer/get_gst_list', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
        }).then(res => {
            dispatch({
                type: GST_NUMBER,
                payload: res?.data?.data
            })
        }).catch(error => {
            if (error?.response?.status === 401) {
                dispatch(refreshToken())
                dispatch(getGstNumber())
            }
        });
    }
};

export const getMobileDatumFuelLevel = (formData, enqueueSnackbar) => {
    return (dispatch) => {
        reposWebApi.get("/customer/get_asset_data", {
            headers: {
                Authorization: "Bearer " + secureLocalStorage.getItem("access_token"),
            },
            params: formData,
        })
            .then((response) => {
                dispatch({
                    type: GET_FUEL_LEVEL,
                    payload: response?.data?.data,
                });
            })
            .catch(async (error) => {
                if (error?.response?.status === 401) {
                    await dispatch(refreshToken());
                    dispatch(getAssetAnalytics());
                } else {
                    enqueueSnackbar("Something Went Wrong..!", {
                        variant: 'error',
                        horizontal: 'center'
                    });
                    dispatch({
                        type: GET_ANALYTICS_REPORT_FAIL,
                    });
                }

            });
    };
};

export const externalRefill = (data, fetchMoreData) => {
    return async (dispatch) => {
        if (!fetchMoreData) {
            dispatch({
                type: ASSET_LOADING,
                payload: false
            });
        }
        await reposWebApi.get('/order/list/ext_order', {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            },
            params: data
        }).then(res => {
            dispatch({
                type: EXTERNAL_REFILL,
                payload: res?.data?.data
            })
        }).catch(error => {
            if (error?.response?.status === 401) {
                dispatch(refreshToken())
                dispatch(externalRefill())
            }
        });
    }
};

export const addExternalRefill = (params, enqueueSnackbar, callbacks = {}) => {
    return (dispatch) => {
        dispatch({ type: ASSET_LOADING });

        reposWebApi.post('/order/create/ext_order', qs.stringify(params), {
            headers: {
                Authorization: 'Bearer ' + secureLocalStorage.getItem("access_token")
            }
        })
            .then(response => {
                dispatch({
                    type: ADD_EXTERNAL_REFILL,
                    payload: response?.data?.data
                });

                const msg = response?.data?.data?.msg || "Refill added successfully";
                enqueueSnackbar(msg, {
                    variant: 'success',
                    anchorOrigin: { vertical: 'top', horizontal: 'right' }
                });

                if (typeof callbacks.onSuccess === "function") callbacks.onSuccess();

                dispatch(externalRefill({
                    limit: 5,
                    offset: 0,
                    customer_asset: params.customer_asset
                }));
            })
            .catch(error => {
                let msg = "Something went wrong";

                if (error?.response?.status === 406) {
                    msg = error?.response?.data?.data?.msg;
                } else if (error?.response?.status === 502) {
                    msg = "Server error";
                } else if (error?.response?.status === 500) {
                    msg = "Invalid values";
                }

                enqueueSnackbar(msg, {
                    variant: 'error',
                    anchorOrigin: { vertical: 'top', horizontal: 'right' }
                });

                if (typeof callbacks.onFailure === "function") callbacks.onFailure();

                dispatch({ type: ADD_EXTERNAL_REFILL_ERROR, payload: true });
            });
    };
};




